module.exports = __webpack_public_path__ + "static/media/MANEJO_ALMACEN.85a4f1aa.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/archivos/MANEJO_ALMACEN.pdf
// module id = 75
// module chunks = 0